// 計測に載せるプラン名。
//
// planId は無料プランのとき null、チームの情報をまだ読めていないとき
// undefined になる。undefined をそのまま Mixpanel に渡すとプロパティごと
// 落ちてしまい、「無料から有料へ変えようとした人」と「プランを読めて
// いなかった人」を後から区別できなくなる。必ず文字列にして渡す。
const planLabel = (planId: string | null | undefined): string => {
  if (planId === undefined) {
    return 'unknown';
  }

  if (planId === null) {
    return 'free';
  }

  return planId;
};

export default planLabel;
